import { __assign, __rest } from "tslib";
import { jsx as _jsx } from "react/jsx-runtime";
import * as React from 'react';
import classnames from 'classnames';
import { PopperStyled, Root, PaperStyled } from './PopperDropDown.styles';
import ClickAwayListener from '../ClickAwayListener';

var PopperDropDown = function PopperDropDown(_a) {
  var _b = _a.active,
      active = _b === void 0 ? false : _b,
      _c = _a.hideBackdrop,
      hideBackdrop = _c === void 0 ? true : _c,
      onPaperClickStart = _a.onPaperClickStart,
      onPaperClickEnd = _a.onPaperClickEnd,
      onClose = _a.onClose,
      className = _a.className,
      _d = _a.placement,
      placementProp = _d === void 0 ? 'bottom-start' : _d,
      anchorEl = _a.anchorEl,
      TransitionProps = _a.TransitionProps,
      paperClassName = _a.paperClassName,
      paperRef = _a.paperRef,
      minWidth = _a.minWidth,
      children = _a.children,
      props = __rest(_a, ["active", "hideBackdrop", "onPaperClickStart", "onPaperClickEnd", "onClose", "className", "placement", "anchorEl", "TransitionProps", "paperClassName", "paperRef", "minWidth", "children"]);

  var handlePaperClickStart = React.useCallback(function () {
    onPaperClickStart && onPaperClickStart();

    var handlePaperClickEnd = function handlePaperClickEnd() {
      onPaperClickEnd && onPaperClickEnd();
      document.removeEventListener('mouseup', handlePaperClickEnd);
      document.removeEventListener('touchend', handlePaperClickEnd);
    };

    document.addEventListener('mouseup', handlePaperClickEnd);
    document.addEventListener('touchend', handlePaperClickEnd);
  }, [onPaperClickStart, onPaperClickEnd]);
  var handleClickAway = React.useCallback(function () {
    if (onClose && active) {
      onClose();
    }
  }, [onClose, active]);
  return _jsx(PopperStyled, __assign({
    placement: placementProp,
    anchorEl: anchorEl,
    TransitionProps: __assign({
      timeout: 300,
      classNames: 'grow'
    }, TransitionProps),
    onClose: onClose,
    hideBackdrop: hideBackdrop,
    className: classnames(className, {
      withBackdrop: !hideBackdrop
    }),
    style: props.strategy === 'fixed' ? {
      position: 'fixed'
    } : undefined
  }, props, {
    children: _jsx(Root, __assign({
      className: "ui-popper-dropdown__root"
    }, {
      children: _jsx(ClickAwayListener, __assign({
        onClickAway: handleClickAway
      }, {
        children: _jsx(PaperStyled, __assign({
          shadow: "popover",
          tabIndex: -1,
          role: "document",
          onMouseDown: handlePaperClickStart,
          onTouchStart: handlePaperClickStart,
          className: paperClassName,
          ref: paperRef,
          style: minWidth != null ? {
            minWidth: minWidth
          } : undefined
        }, {
          children: children
        }))
      }))
    }))
  }));
};

export default React.memo(PopperDropDown);